export default __webpack_public_path__ + "static/cooking-potatoes-01df118a53c2f5dd38e7e0768cf70b9f.svg";